export default __webpack_public_path__ + "static/media/welded-wire-mesh.1ad6d248.jpg";